import React from "react";
import { DataTable, useWindowWidth, } from "@sscs/ui";
import NetworkingRow from "./NetworkingRow/NetworkingRow";
const NetworkingTable = ({ networkingItems, sort, searchRegex, filters, onSortChange, status, itemCount, pagination, onPaginationChange, }) => {
    const windowWidth = useWindowWidth();
    const isWide = windowWidth > 1400;
    const columns = [
        { id: "info", label: "Info", width: "70px" },
        {
            id: "value",
            label: "Value",
            sortProperty: "value",
            sortId: "networking-sort-value",
            width: "100%",
        },
        {
            id: "threat",
            label: "Threat name",
            sortProperty: "classification_result",
            sortId: "networking-sort-threat-name",
            width: isWide ? "400px" : "300px",
        },
        {
            id: "tags",
            label: "Tags",
            sortProperty: "tag_count",
            sortId: "networking-sort-tags",
            startReverse: true,
            width: isWide ? "250px" : "200px",
        },
        {
            id: "count",
            label: isWide ? "Count" : "#",
            sortProperty: "component_count",
            sortId: "networking-sort-count",
            startReverse: true,
            width: isWide ? "110px" : "60px",
        },
    ];
    return (React.createElement(DataTable, { size: "small", columns: columns, sort: sort, onSortChange: onSortChange, status: status, empty: { subject: "URLs", filters }, pagination: {
            id: "networking-pagination",
            itemCount,
            pagination,
            onChange: onPaginationChange,
        } }, networkingItems.map((elem, index) => (React.createElement(NetworkingRow, { rowIndex: index, key: elem.id, networking: elem, searchRegex: searchRegex })))));
};
export default NetworkingTable;
//# sourceMappingURL=NetworkingTable.js.map